import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useFleetLocationsLogic = () => {
  const apiRoute = "fleetlocations";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Name",
      type: "text",
      isRequired: true,
      err: "Name is required",
      returnID: true,
    },
    {
      name: "branch",
      label: "Branch",
      type: "dropdown",
      isRequired: true,
      err: "Branch is required",
      returnID: true,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      isRequired: true,
      err: "City is required",
    },
    {
      name: "state",
      label: "State",
      type: "text",
      isRequired: true,
      err: "State is required",
    },
    {
      name: "longitude",
      label: "Longitude",
      type: "text",
      err: "Longitude is required",
      decimalCount: 12,
    },
    {
      name: "latitude",
      label: "Latitude",
      type: "text",
      err: "Latitude is required",
      decimalCount: 12,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      err: "Email is required",
    },
    {
      name: "phone_number",
      label: "Phone Number",
      type: "phone",
      err: "Phone Number is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;

  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin];

  const getPromises = (temp) => {
    return [fetchDataAndMapToField(config, "branches", "branch", temp, "Name")];
  };
  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useFleetLocationsLogic;
